
<template>
  <div>
    <v-dialog v-model="dialog" scrollable  persistent max-width="700px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Boleto</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <BillProfile :id="id"></BillProfile>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn text @click="closeDialog">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogShowBill',
  components:{
    BillProfile: () => import('@/_backoffice/_financial/components/bill/shared/BillProfile.vue')
  },
  props: {
    id: {
      type: [Number, String],
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
  },
  watch: {
    dialog(nv,ov) {
      if (nv == false){
        this.$emit('closeDialog')
      }
    }
  },
}
</script>